var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 23.0333L10.4667 26.3666C10.2222 26.5222 9.96666 26.5888 9.7 26.5666C9.43333 26.5444 9.2 26.4555 9 26.2999C8.8 26.1444 8.64444 25.9502 8.53333 25.7173C8.42222 25.4844 8.4 25.223 8.46666 24.9333L9.93333 18.6333L5.03333 14.3999C4.81111 14.1999 4.67244 13.9719 4.61733 13.7159C4.56222 13.4599 4.57866 13.2102 4.66666 12.9666C4.75466 12.723 4.888 12.523 5.06666 12.3666C5.24533 12.2102 5.48977 12.1102 5.8 12.0666L12.2667 11.4999L14.7667 5.5666C14.8778 5.29994 15.0502 5.09993 15.284 4.9666C15.5178 4.83327 15.7564 4.7666 16 4.7666C16.2436 4.7666 16.4822 4.83327 16.716 4.9666C16.9498 5.09993 17.1222 5.29994 17.2333 5.5666L19.7333 11.4999L26.2 12.0666C26.5111 12.111 26.7556 12.211 26.9333 12.3666C27.1111 12.5222 27.2444 12.7222 27.3333 12.9666C27.4222 13.211 27.4391 13.4613 27.384 13.7173C27.3289 13.9733 27.1898 14.2008 26.9667 14.3999L22.0667 18.6333L23.5333 24.9333C23.6 25.2222 23.5778 25.4835 23.4667 25.7173C23.3556 25.9511 23.2 26.1453 23 26.2999C22.8 26.4546 22.5667 26.5435 22.3 26.5666C22.0333 26.5897 21.7778 26.523 21.5333 26.3666L16 23.0333Z",
    fill: "#EE77A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFill);
export default __webpack_public_path__ + "static/media/starFill.bd4bf4e3cd2d6d4dcf49ff21ce5a7c6e.svg";
export { ForwardRef as ReactComponent };